import './App.css';

function App() {
  return (
    <div>    
    <center><h1><b><i>Ethical Hacker's Life </i></b></h1></center>
    
   <div class="middle">
     <ol>
     <li>
     <h4><a href="https://copyright.gov.in/SearchRoc.aspx">Crypto Ransomware- Computer Virus (Ransomware) And Its Antivirus.</a></h4>
     Diary number: 3512/2016-CO/SW
     <p align="justify">
     This Java-based cryptographic file-encryption program and its corresponding recovery/antivirus component were developed as part of early academic research in cybersecurity. The project explored file-locking behavior, directory-level processing, and defensive restoration techniques in controlled test environments. The software was created solely for research and learning purposes and is registered with the Copyright Office of India.
     </p>
     <p>
     <u>Resources</u>:
     <br/>
     <ol>
     <li>Copyright Office: <a target="_blank" rel="noopener noreferrer" href="http://copyright.gov.in/SearchRoc.aspx">click here</a></li>
     </ol>
     </p>
     </li>
     <li>
     <h4><a href="https://copyright.gov.in/SearchRoc.aspx">Cryptbits: Computer Ransomware and its reversal code.</a></h4>
      Diary number: 6429/2020-CO/SW
     <p align="justify">
     Cryptbits is a Java-based cryptographic file-encryption program developed as part of academic cybersecurity research. It uses AES-128 in CBC mode with PBKDF2-based key derivation to encrypt files recursively and includes a corresponding recovery mechanism to restore encrypted data. The program was created and evaluated strictly in a controlled environment and is registered with the Copyright Office of India.
     </p>
     <p>
     <u>Resources</u>:
     <br/>
     <ol>
     <li>Copyright Office: <a target="_blank" rel="noopener noreferrer" href="http://copyright.gov.in/SearchRoc.aspx">click here</a></li>
     </ol>
     </p>
     </li>

     <li>
     <h4><a href="https://github.com/mr-ravin/FileCrypt">FileCrypt - an opensource file encryption tool.</a></h4>
     <p align="justify">
     FileCrypt is an opensource android application able to perform AES-128 bit encryption on all types of files.
     <p>
     <u>Resources</u>:
     <br/>
     <ol>
     <li>App available on: <a href="https://play.google.com/store/apps/details?id=ravin.developer.filecrypt">Google Playstore</a>   </li>
     <li>Source Code: <a href="https://github.com/mr-ravin/FileCrypt">Github Repository</a></li>
     </ol>
     </p>    
     </p>
     </li>

     <li>
     <h4><a href="https://github.com/mr-ravin/EnText">EnText - an opensource text encryption tool.</a></h4>  
     <p align="justify">
     An opensource text encryption tool for android using AES-128 bit encryption with CBC, which is considered good for providing security for general use cases, please do consult your cybersecurity adviser if you are looking for a very specific use case.
     </p>
     <p>
     <u>Resources</u>:
     <br/>
     <ol>
     <li>App available on: <a href="https://play.google.com/store/apps/details?id=ravin.developer.entext">Google Playstore</a></li>
     <li>Source Code: <a href="https://github.com/mr-ravin/entext"> Github Repository</a></li>
     </ol>
     </p>
     </li>

     <li>
     <h4><a href="https://github.com/mr-ravin/PasswordManager-Android-App">Password Manager - CyberSecure.</a></h4>  
     <p align="justify">
     This opensource android application stores all of its data in a 256 bit encrypted format on the device itself, thus it works completely offline.
     </p>
     <p>
     <u>Resources</u>:
     <br/>
     <ol>
     <li>App available on: <a href="https://play.google.com/store/apps/details?id=ravin.developer.passwordmanager">Google Playstore</a> </li>
     <li>Source Code: <a href="https://github.com/mr-ravin/PasswordManager-Android-App"> Github Repository</a></li>
     </ol>
     </p>
     </li>

     <li>
     <h4><a href="https://github.com/mr-ravin/ConfiBook-Android-App">ConfiBook - an encrypted book.</a></h4>
     <p align="justify">
     This opensource android application stores all of its data in a 256 bit encrypted format on the device itself, thus it works completely offline.
     </p>
     <p>
     <u>Resources</u>:
     <br/>
     <ol>
     <li>App available on: <a href="https://play.google.com/store/apps/details?id=ravin.developer.confidentialbook">Google Playstore</a>   </li>
     <li>Source Code: <a href="https://github.com/mr-ravin/ConfiBook-Android-App"> Github Repository</a></li>
     </ol>
     </p>
     </li>

     </ol>
    </div>
    </div>
  );
}

export default App;
